var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finish"},[(_vm.useLogo)?_c('img',{staticClass:"logo",attrs:{"src":require("@/images/goods_rank/bottom_tip_logo_mall.png")}}):_c('span',[_vm._v("-已经到底啦-")])])}
var staticRenderFns = []

export { render, staticRenderFns }